import { colors } from 'fitify-ui'
import { biggerPhone, phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledMuscleLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 40px;

  ${biggerPhone(css`
    gap: 24px;
  `)};

  ${phone(css`
    flex-direction: column;
  `)};
`

export const StyledDiagramWrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 24px;
  border-radius: 16px;
  background-color: ${colors.White};

  ${biggerPhone(css`
    padding: 16px;
  `)};

  ${phone(css`
    padding: 10px;
  `)};
`

export const StyledMuscleLists = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  gap: 24px;
`
